<mat-dialog-content>
  <div class="dialog-content-container">
    <div class="dialog-title text-center mb-4">{{ title }}</div>

    <div class="nfc-section mb-3">
      <button
        class="btn btn-outline-primary w-100 py-3 d-flex align-items-center justify-content-center"
        (click)="scanNFC()">
        <mat-icon class="me-2">nfc</mat-icon>
        <span>Scan NFC Card</span>
      </button>
    </div>

    <div class="form-group mb-3">
      <mat-form-field floatLabel="always" appearance="outline" class="w-100">
        <mat-label>Staff ID</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [(ngModel)]="keyword" (keydown.enter)="search($event)"
               type="text"
               required
               placeholder="Enter Staff ID">
      </mat-form-field>
    </div>

    <div class="staff-info py-2 px-2 highlight-background" *ngIf="staff" (click)="submit()">
      <div class="d-flex align-items-center mb-2">
        <div class="symbol-circle me-2">{{ staff?.name?.charAt(0).toUpperCase() }}</div>
        <div>
          <span class="staff-name text-dark me-2">{{ staff?.name }}</span><br>
          <span class="staff-staff-no text-muted-700 small">{{ staff?.staffNo }}</span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="action-buttons-container d-flex justify-content-center w-100 p-3">
    <div class="cancel-button-container col-4 me-3">
      <button class="btn btn-light border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Cancel</span>
      </button>
    </div>
    <div class="search-button-container col-8">
      <button
        class="btn btn-primary text-white w-100 h-100 d-flex align-items-center justify-content-center"
        (click)="search()"
        [disabled]="!keyword">
        <i class="fa fa-search me-2"></i>
        <span>Search</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
